import { getPixiComponent } from './pixiComponent';

const DefaultPixiComponent = getPixiComponent();

export default async function addFreecodeGraphics(graphicData, PixiComponent = DefaultPixiComponent) {
  const loadedImage = await new Promise((resolve, reject) => {
    let img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.crossOrigin = 'anonymous';
    img.src = graphicData.url;
  });
  if (graphicData.jsonData) loadedImage.sheetData = graphicData.jsonData;
  loadedImage.name = graphicData.name;
  PixiComponent.addPreloadedImage(loadedImage);
}
